export const REQUEST_SUCCESS = 'REQUEST_SUCCES';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCES';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/users/types.js